import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';
import emailjs from '@emailjs/browser';

// Configuration EmailJS
const EMAILJS_SERVICE_ID = 'service_gs8bk8b';
const EMAILJS_TEMPLATE_ID = 'template_rq3u69d';
const EMAILJS_PUBLIC_KEY = '8yUheh-3kP_1Ni9MK';

const Contact = () => {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus({ type: '', message: '' });

    emailjs.sendForm(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      formRef.current,
      EMAILJS_PUBLIC_KEY
    )
      .then((result) => {
        console.log('Email envoyé:', result.text);
        setStatus({ type: 'success', message: 'Message envoyé avec succès ! Nous vous répondrons rapidement.' });
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      })
      .catch((error) => {
        console.error('Erreur:', error.text);
        setStatus({ type: 'error', message: 'Une erreur est survenue. Veuillez réessayer ou nous contacter par téléphone.' });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Contactez-nous</h2>
          <p>Nous sommes à votre écoute pour répondre à toutes vos questions</p>
        </motion.div>
        <div className="contact-content">
          <motion.div 
            className="contact-info"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="info-item">
              <FaMapMarkerAlt />
              <div>
                <h4>Adresse</h4>
                <p>122 Avenue de la resistance<br />93340 le Raincy, France</p>
              </div>
            </div>
            <div className="info-item">
              <FaPhone />
              <div>
                <h4>Téléphone</h4>
                <p>+33 6 67 52 03 87</p>
              </div>
            </div>
            <div className="info-item">
              <FaEnvelope />
              <div>
                <h4>Email</h4>
                <p>contact@driveinternational.fr</p>
              </div>
            </div>
            <div className="info-item">
              <FaClock />
              <div>
                <h4>Horaires</h4>
                <p>Lun - Ven: 9h00 - 18h00</p>
              </div>
            </div>
          </motion.div>
          <motion.form 
            ref={formRef}
            className="contact-form"
            onSubmit={handleSubmit}
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            {status.message && (
              <div className={`form-status ${status.type}`}>
                {status.message}
              </div>
            )}
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Votre nom"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Votre email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="tel"
                name="phone"
                placeholder="Votre téléphone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <select
                name="subject"
                value={formData.subject}
                onChange={handleChange}
              >
                <option value="">Sujet de votre demande</option>
                <option value="transport">Transport & Logistique</option>
                <option value="admin">Gestion Administrative</option>
                <option value="conseil">Conseil Stratégique</option>
                <option value="autre">Autre demande</option>
              </select>
            </div>
            <div className="form-group">
              <textarea
                name="message"
                placeholder="Votre message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <button type="submit" className="btn btn-primary" disabled={isLoading}>
              {isLoading ? 'Envoi en cours...' : 'Envoyer le message'}
            </button>
          </motion.form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
